
export class Constants {
    static DELIVERY_EDIT_MODE_SELECT_PREFIX = 'delivery-package-edit-';
    static SELECTED_CAMERA_SCAN_PREFIX = 'xpm-camera-selected-scan-';
}
